import { CityState, DataSource, Image, Label, Layout, Panel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMultiStop extends Layout {
    citystateConsignee: CityState;
    citystateCustomer: CityState;
    citystateManifestConsignee: CityState;
    citystateManifestCust: CityState;
    citystateManifestShipper: CityState;
    citystateShipper: CityState;
    imageMPact: Image;
    imageManifestMPact: Image;
    labelAddress1: Label;
    labelAddress2: Label;
    labelBillDistanceUm: Label;
    labelBillingDistance: Label;
    labelContactPhone: Label;
    labelCustomerName: Label;
    labelCustomers: Label;
    labelDistance: Label;
    labelManifestCustAddress1: Label;
    labelManifestDistance: Label;
    labelManifestSmartTarget: Label;
    labelMoveDistance: Label;
    labelMoveDistanceUm: Label;
    labelSmartTarget: Label;
    panelComDist: Panel;
    panelCommodity: Panel;
    panelCustomer: Panel;
    panelDistance: Panel;
    panelMPact: Panel;
    panelManifestComDist: Panel;
    panelManifestCommodity: Panel;
    panelManifestCustomers: Panel;
    panelManifestDistance: Panel;
    panelManifestInfo: Panel;
    panelManifestMPact: Panel;
    panelManifestOriginDest: Panel;
    panelManifestStopInfo: Panel;
    panelManifestTargetPay: Panel;
    panelManifestWeight: Panel;
    panelOrderInfo: Panel;
    panelOriginDest: Panel;
    panelStopInfo: Panel;
    panelTargetPay: Panel;
    panelWeight: Panel;
    sourceDetentionHist: DataSource;
    sourceDetentionHistChg: DataSource;
    sourceDetentionHistPay: DataSource;
    sourceManifestMultistop: DataSource;
    sourceMultiStop: DataSource;
    sourceStop: DataSource;
    tableStop: Table;
    textboxCommodityId: Textbox;
    textboxCommodityIds: Textbox;
    textboxManifestCustomers: Textbox;
    textboxManifestPnnRate: Textbox;
    textboxManifestTargetPay: Textbox;
    textboxManifestTrailerType: Textbox;
    textboxManiftestMaxPay: Textbox;
    textboxMaxPay: Textbox;
    textboxName: Textbox;
    textboxPnnRate: Textbox;
    textboxTargetPay: Textbox;
    textboxTotalWeight: Textbox;
    textboxTrailerType: Textbox;
    textboxWeight: Textbox;
}
